<h2 mat-dialog-title class="dialog_title">
    <span (click)="log()">
        {{ "Language Version" | translate }}:
    </span>
    <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
    </button>
</h2>
<mat-dialog-content class="mat-typography">
    <div class="container">
        <!-- <mat-chip-list class="interface_selected">
            <ng-container *ngIf="parameter_value && parameter_value.length">
                <ng-container *ngFor="let val of parameter_value">
                    <mat-chip color="primary" selected (removed)="removeItem(val)">
                        {{ val?.value }}
                        <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                </ng-container>
            </ng-container>
            
            <input class="chips_search" placeholder="{{ 'Search' | translate }}" [formControl]="allValuesControl">
        </mat-chip-list> -->

        <mat-form-field appearance="legacy" class="full_width_form">
            <mat-label class="mr-1">{{ 'Search' | translate }}</mat-label>
            <mat-icon matPrefix>search</mat-icon>
            <input [formControl]="allValuesControl" matInput>
            <button mat-icon-button matSuffix (click)="emptySearch()">
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>

        <mat-selection-list [compareWith]="compareFn" class="interface_list" [multiple]="true" [(ngModel)]="parameter_value" (selectionChange)="selectChange($event)" [appDeviceClass]="'custom-scroll'">
            <mat-list-option *ngFor="let item of allValues$ | async" [value]="item">
                <span>{{ item.value }}</span>
            </mat-list-option>
        </mat-selection-list>
        <p class="text">The language Version tag will be set as a primary for the selected files (if tag is not set to file then it will be set)</p>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <div class="btns">
        <button mat-raised-button (click)="close()">
            {{ "Close" | translate }}
        </button>
        <button class="ml-1 d-f-btn" (click)="save()" mat-raised-button cdkFocusInitial color="primary" [disabled]="isSubmit">
            <mat-spinner class="spin_16 mr-1" *ngIf="isSubmit"></mat-spinner>  
            {{ "Save" | translate }}
        </button>
    </div>
</mat-dialog-actions>